import { render } from "./PnLTable.vue?vue&type=template&id=27f22da5&scoped=true"
import script from "./PnLTable.vue?vue&type=script&lang=js"
export * from "./PnLTable.vue?vue&type=script&lang=js"

import "./PnLTable.vue?vue&type=style&index=0&id=27f22da5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f22da5"]])

export default __exports__